export default {
    id: '',
    version: '1.0.0',
    schema: '1.0.0',
    configuration: {},
};
